import { Link } from "react-router-dom";

import InstagramIcon from "@mui/icons-material/Instagram";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        padding: "2rem 1rem",
        textAlign: "center",
        background: "#f3f8f2",
        fontSize: "0.9rem",
      }}
    >
      <nav
        style={{
          marginBottom: "1rem",
          display: "flex",
          justifyContent: "center",
          gap: "1.5rem",
          flexWrap: "wrap",
        }}
      >
        <Link to="/faq" style={{ textDecoration: "none", color: "#192b36" }}>
          FAQs
        </Link>
        <Link
          to="/terms-conditions"
          style={{ textDecoration: "none", color: "#192b36" }}
        >
          Terms
        </Link>
        <Link
          to="/privacy-policy"
          style={{ textDecoration: "none", color: "#192b36" }}
        >
          Privacy Policy
        </Link>
        <a
          href="https://www.instagram.com/joinfudopia"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#192b36",
            display: "inline-flex",
            alignItems: "center",
            gap: "0.3rem",
          }}
        >
          <InstagramIcon fontSize="small" />
        </a>
      </nav>
      <div style={{ color: "#192b36" }}>© Fudopia {year}</div>
    </footer>
  );
}
